import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  FormGroup,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModules } from "@ag-grid-community/all-modules";

import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-alpine.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";

import "./NewCompareQuotation.scss";
import { getUserLocations } from "../../../store/Mini/actions";
import {
  getRFQList,
  SelecteChangeValue,
  getRFQRequestdata,
  getQuotationsData,
  resetCellUpdate,
  CompareQuotationAdd,
  getCompareQuotationData,
} from "../../../store/CompareQuotation/actions";

import ItemNameCellRenderer from "./ItemNameCellRenderer";
import VendorCellRenderer from "./VendorCellRenderer";
import LoadingModel from "../../LoadingModel";

class CompareQuotation extends Component {
  constructor(props) {
    super(props);

    this.state = this.createState();
    this.onSubmit = this.onSubmit.bind(this);
    this.QuotationsData = this.QuotationsData.bind(this);
  }

  createState() {
    const topOptions = {
      alignedGrids: [],
      defaultColDef: {
        autoHeight: true,
        // editable: true,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 350,
      },
      suppressHorizontalScroll: true,
    };
    const bottomOptions = {
      alignedGrids: [],
      defaultColDef: {
        autoHeight: true,
        // editable: true,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 350,
        cellRenderer: "tcvendorCellRenderer",
      },
    };

    topOptions.alignedGrids.push(bottomOptions);
    bottomOptions.alignedGrids.push(topOptions);

    return {
      topOptions,
      bottomOptions,

      getRowHeight: function (params) {
        return 350;
      },
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };
  componentDidUpdate() {
    if (this.props.loading === false) {
      if (this.props.newclm !== "" || this.props.newrow !== -1) {
        var rowNodes = this.gridApi.getDisplayedRowAtIndex(this.props.newrow);
        var params = {
          force: true,
          suppressFlash: true,
          columns: [this.props.newclm, "ItemName"],
          rowNodes: [rowNodes],
        };
        if (this.gridApi) {
          this.gridApi.refreshCells(params);
          this.props.resetCellUpdate();
        }
      }
    }
  }
  componentDidMount() {
    this.props.getRFQList();
    this.props.getUserLocations();
    if (this.props.match.params.id > 0) {
      this.props.getCompareQuotationData(this.props.match.params.id);
    }
  }
  QuotationsData() {
    this.props.getRFQRequestdata(this.props.CQData.rfq_id);
  }
  onSubmit() {
    var error = false;
    var totalqty = 0;
    var totalgross = 0;

    var cqitemsTosave = this.props.CQbodyData.map((item) => {
      var a = [];
      totalqty = 0;
      if (!error) {
        for (const k in item) {
          if (Object.hasOwnProperty.call(item, k)) {
            if (
              k !== "ItemName" &&
              (item[k].Quotationcheck || item[k].dodelete)
            ) {
              var orginalQty =
                item.ItemName.Quantity - item.ItemName.totalpoqty;
              totalqty += parseFloat(
                parseFloat(
                  item[k].ApprovedQuantity ? item[k].ApprovedQuantity : 0
                ).toFixed(3)
              );

              totalgross += parseFloat(
                parseFloat(
                  item[k].updateGrossValue ? item[k].updateGrossValue : 0
                ).toFixed(2)
              );
              if (orginalQty < totalqty) {
                error = true;
                Swal.fire({
                  icon: "info",
                  title:
                    "<strong>Item Quantity more then Required Quantity</strong>",
                });
              } else {
                a.push({
                  id: item[k].id,
                  product_id: item.ItemName.product_id,
                  qty: parseFloat(
                    parseFloat(
                      item[k].ApprovedQuantity ? item[k].ApprovedQuantity : 0
                    ).toFixed(3)
                  ),
                  unit_id: item[k].unit.id,
                  rfqitem_id: item.ItemName.rfqItemId,
                  quotation_id: item[k].quotation_id,
                  vendor_id: item[k].vendorId,
                  tax_id: item[k].tax_id,
                  taxtype: item[k].taxtype,
                  taxamount: parseFloat(item[k].taxamount).toFixed(2),
                  qitem_id: item[k].qitem_id,
                  baseprice: item[k].baseprice,
                  discount: item[k].discount,
                  discountpercent: item[k].discountpercent,
                  price: item[k].Price,
                  gross: parseFloat(
                    parseFloat(
                      item[k].updateGrossValue ? item[k].updateGrossValue : 0
                    ).toFixed(2)
                  ),
                  make: item[k].make,
                  description: item[k].description,
                  dodelete: item[k].dodelete,
                });
              }
            }
          }
        }
      }

      return a;
    });
    if (!error) {
      cqitemsTosave = [].concat.apply([], cqitemsTosave);
    }
    var data = {
      location_id: this.props.userLocation[0].id,
      requestforquotation_id: this.props.RFQrowdata.id,
      total: parseFloat(parseFloat(totalgross ? totalgross : 0).toFixed(2)),
      cqitems: cqitemsTosave,
    };

    this.props.CompareQuotationAdd(
      data,
      this.props.match.params.id,
      this.props.history
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col md={12} className="p-1 W-100">
                <Card className="p-0 ">
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/CompareQuotationDashboard"
                      className="action-icon text-primary mr-2"
                    >
                      {" "}
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      New Compare Quotation
                    </h5>
                  </CardHeader>
                  <CardBody className="p-2 ">
                    <Row>
                      <Col md={5}>
                        <FormGroup className="mb-0 mr-2" row>
                          <Col md={4}>
                            <Label
                              htmlFor="rfqId"
                              className="col-form-label font-size-16"
                            >
                              Select RFQ No:
                            </Label>
                          </Col>
                          <Col md={8}>
                            {this.props.match.params.id === "0" ? (
                              <Select
                                id="rfqId"
                                name="rfqId"
                                classNamePrefix="select2-selection"
                                options={this.props.rfqList.map(
                                  (item, index) => ({
                                    label: item.code,
                                    value: item.id,
                                  })
                                )}
                                value={{
                                  label: this.props.CQData.rfqLabel,
                                  value: this.props.CQData.rfq_id,
                                }}
                                onChange={(e) => {
                                  this.props.SelecteChangeValue({
                                    key: "rfqLabel",
                                    label: e.label,
                                    key2: "rfq_id",
                                    value: e.value,
                                  });
                                }}
                              />
                            ) : (
                              <Input
                                className="pr-0 "
                                placeholder="RQF NO"
                                type="text"
                                disabled={true}
                                name="rfqNo"
                                id="rfqNo"
                                value={this.props.RFQrowdata.code}
                              />
                            )}
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          color="primary"
                          style={{ width: "100%" }}
                          className="waves-effect waves-light "
                          onClick={() => this.QuotationsData()}
                          disabled={
                            this.props.match.params.id !== "0" ? true : false
                          }
                        >
                          Load Data
                        </Button>
                        {/* </div> */}
                      </Col>
                      <Col md={5}></Col>
                    </Row>
                    <Row>
                      <Col md={12} className="m-1">
                        <Card className="pt-1">
                          <CardBody className="p-1">
                            {this.props.RFQCellData.length === 0 ? (
                              <div className="text-center pt-2">
                                <span className="font-size-22 text-danger">
                                  Please Select RFQ{" "}
                                </span>
                              </div>
                            ) : (
                              <>
                                {this.props.loading === true ? (
                                  <div className="text-center pt-2">
                                    <span className="font-size-22 text-danger">
                                      Loading...{" "}
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      height: "970px",
                                    }}
                                    className="ag-theme-balham"
                                  >
                                    <div
                                      style={{
                                        flex: "1 1 auto",
                                        maxHeight: "600px",
                                      }}
                                    >
                                      <AgGridReact
                                        rowData={this.props.CQbodyData}
                                        gridOptions={this.state.topOptions}
                                        onGridReady={this.onGridReady}
                                        columnDefs={this.props.RFQCellData.map(
                                          (vend, Key) => {
                                            if (Key === 0) {
                                              vend.field = vend.CellName;
                                              vend.width = 250;
                                              vend.wrapText = true;
                                              vend.pinned = "left";
                                              vend.suppressMovable = false;
                                              vend.lockPosition = true;
                                              vend.cellClass = "locked-col";
                                              vend.cellRenderer =
                                                "itemNameCellRenderer";

                                              vend.autoHeight = true;
                                            } else {
                                              vend.field = vend.CellName;
                                              vend.wrapText = true;
                                              vend.suppressMovable = false;
                                              vend.width = 250;
                                              vend.cellRenderer =
                                                "vendorCellRenderer";
                                            }
                                            return vend;
                                          }
                                        )}
                                        frameworkComponents={{
                                          itemNameCellRenderer:
                                            ItemNameCellRenderer,
                                          vendorCellRenderer:
                                            VendorCellRenderer,
                                        }}
                                        getRowHeight={this.state.getRowHeight}
                                        modules={AllCommunityModules}
                                      />
                                    </div>

                                    <div
                                      style={{ flex: "none", height: "370px" }}
                                    >
                                      <AgGridReact
                                        rowData={this.props.CQBodyTCData}
                                        gridOptions={this.state.bottomOptions}
                                        columnDefs={this.props.RFQCellData.map(
                                          (vend, Key) => {
                                            if (Key === 0) {
                                              vend.field = vend.CellName;
                                              vend.width = 250;
                                              vend.wrapText = true;
                                              vend.pinned = "left";
                                              vend.suppressMovable = false;
                                              vend.lockPosition = true;
                                              vend.cellRenderer =
                                                "itemNameCellRenderer";

                                              vend.autoHeight = true;
                                            } else {
                                              vend.field = vend.CellName;
                                              vend.wrapText = true;
                                              vend.suppressMovable = false;
                                              vend.width = 250;
                                              vend.cellRenderer =
                                                "vendorCellRenderer";
                                            }
                                            return vend;
                                          }
                                        )}
                                        frameworkComponents={{
                                          itemNameCellRenderer:
                                            ItemNameCellRenderer,
                                          vendorCellRenderer:
                                            VendorCellRenderer,
                                        }}
                                        getRowHeight={this.state.getRowHeight}
                                        headerHeight="0"
                                        modules={AllCommunityModules}
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <CardFooter className="bg-transparent p-1">
                      <div className="float-right">
                        <Button
                          type="reset"
                          color="light"
                          className="waves-effect waves-light mr-2"
                          href="/CompareQuotationDashboard"
                        >
                          Cancel
                        </Button>
                        {this.props.loading !== true && (
                          <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light"
                            onClick={this.onSubmit}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </CardFooter>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userLocation } = state.Mini;
  const {
    rfqList,
    RFQCellData,
    CQbodyData,
    CQBodyTCData,
    loading,
    newrow,
    newclm,
    CQData,
    RFQrowdata,
    CQPOList,
  } = state.CompareQuotation;
  return {
    userLocation,
    rfqList,
    RFQCellData,
    CQData,
    CQbodyData,
    CQBodyTCData,
    loading,
    newrow,
    newclm,
    RFQrowdata,
    CQPOList,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getRFQList,
  SelecteChangeValue,
  getRFQRequestdata,
  getQuotationsData,
  resetCellUpdate,
  CompareQuotationAdd,
  getCompareQuotationData,
})(CompareQuotation);
